import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const ChartTimeFrames = {
	3: "3M",
	6: "6M",
	12: "1R",
	36: "3R",
	60: "5R",
	9999: "Vše",
} as const;

export type ChartTimeFrameKey = keyof typeof ChartTimeFrames;
export type ChartTimeFrameValue = (typeof ChartTimeFrames)[ChartTimeFrameKey];

export const allActivityCreated = [
	"Gajdoš Karel [000056]",
	"Novák Petr [000002]",
	"Adam Srstina [000002]",
	"Ondra Test [123001]",
] as const;

type MyPlannActivityCreated = (typeof allActivityCreated)[number];

export const allActivityTypes = ["meet", "task", "note"] as const;

type MyPlannActivityType = (typeof allActivityTypes)[number];

export type MyPlannActivity = {
	id: number;
	type: MyPlannActivityType;
	title: string;
	created: MyPlannActivityCreated;
	dateFrom: Date;
	dateTo?: Date;
	finished: boolean;
};

export type PortfolioDetailProps = {
	baseData: PortfolioDetailResponseDTO;
	currencySign: string;
};
